// extracted by mini-css-extract-plugin
export default {"topbarMenu":"TopbarMenu_topbarMenu__UBjZi"};